import React from "react";
// import { CheckSquare } from 'feather-icons-react';
import { Container, Col, Row, Card, Button, Alert } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import SplitNumber from "../../../components/SplitNumber";
import {
  IconCheck,
  IconCheckCircle,
  IconTooman,
} from "../../../../assets/icons";

function SuccessByWallet(props) {
  const location = useLocation();

  return (
    <>
      <Container className="my-auto text-center" style={{ maxWidth: "500px" }}>
        <Card
          className="rounded-4  shadow-sm"
          style={{ border: "1px solid #d2ebe0" }}
        >
          <Card.Header
            className=" very-large-icons border-bottom-0 rounded-top-4 pt-3 pb-4"
            style={{ background: "#e3f9ef" }}
          >
            <IconCheckCircle fillColor="#09a463" />
            <div className="text-success fw-bold fs-103 mt-2">پرداخت موفق</div>
            <div className="text-success mt-1 fs-08">
              سفارش با موفقیت ثبت گردید.
            </div>
          </Card.Header>
          <Card.Body>
            <Row className=" mt-3 mb-4">
              <Col xs="12" className="fs-09">
                مبلغ{" "}
                <span className="fs-101 fw-bold">
                  <SplitNumber number={props.amount}></SplitNumber>
                </span>
                <span className="px-1 d-inline-block">تومان</span>
                <span>از کیف پول شما</span>
                <span className="fw-bold ps-1">کسر گردید.</span>
              </Col>
            </Row>
            <Row className=" py-1 fs-085">
              <Col xs="auto">شماره سفارش</Col>
              <Col className="my-auto opacity-10 px-0">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="fw-bold">
                {props.reserveId}
              </Col>
            </Row>
            <Row className=" py-3 fs-085">
              <Col xs="auto"> موجودی کیف پول</Col>
              <Col className="my-auto opacity-10 px-0">
                <div
                  style={{
                    borderTop: "1px dashed #000",
                    height: "1px",
                  }}
                ></div>
              </Col>
              <Col xs="auto" className="fw-bold">
                <SplitNumber
                  number={props.userWalletRiallBalance}
                ></SplitNumber>{" "}
                <IconTooman style={{ marginTop: "-12px" }} />
              </Col>
            </Row>
          </Card.Body>
          <Card.Footer className="border-top-0 rounded-bottom-4 py-3">
            <Link
              to={{
                pathname: `/order/orderDetail/${props.basketId}`,
                state: {
                  statusList: location.state?.statusList,
                  title: location.state?.title,
                  basketId: props.basketId,
                },
              }}
            >
              <Button
                className="px-4 fs-085 rounded-pill"
                variant="outline-success"
              >
                پیگیری سفارش
              </Button>
            </Link>
          </Card.Footer>
        </Card>
      </Container>
    </>
  );
}

export default SuccessByWallet;
